<template>
    <wrapper>
        <div class="benefits">
            <div class="card border-0 benefits-card d-flex flex-column flex-lg-row justify-content-between p-5 py-4">
                <div class="benefits-card-content d-flex align-items-center align-items-lg-start flex-column my-auto mx-auto">
                    <div class="title-underlined">{{ $t('whyTrim') }}</div>
                    <div class="text-center text-lg-start">
                        <p v-html="text"></p>
                    </div>
                </div>

                <div class="benefits-card-icons row">
                    <div class="d-flex flex-lg-row flex-column col-6 col-lg-4 px-1 py-3 py-lg-0" v-for="(benefit, i) in benefits" :key="i">
                        <div class="d-flex align-items-center justify-content-center">
                            <img height="50" width="50" contain :src="benefit.src" :alt="benefit.alt" />
                        </div>
                        <div class="d-flex mt-2 align-items-center text-center text-lg-start justify-content-center ms-lg-4 benefit-text" v-html="benefit.text"></div>
                    </div>
                </div>
            </div>
        </div>
    </wrapper>
</template>

<script>
    import Wrapper from '@/components/common/wrapper.vue';

    export default {
        name: 'products',

        components: {
            'wrapper': Wrapper
        },

        props: {
            text: {
                type: String
            }
        },

        data() {
            return {
                benefits: [
                    { text: this.$t('livePerson'), src: '/src/assets/main/benefits/person.svg', alt: this.$t('person') },
                    { text: this.$t('promtReply'), src: '/src/assets/main/benefits/envelope.svg', alt: this.$t('envelope') },
                    { text: this.$t('qualityProducts'), src: '/src/assets/main/benefits/first.svg', alt: this.$t('first') },
                    { text: this.$t('typicalLead'), src: '/src/assets/main/benefits/calendar.svg', alt: this.$t('calendar') },
                    { text: this.$t('noDrop'), src: '/src/assets/main/benefits/shipping.svg', alt: this.$t('shipping') },
                    { text: this.$t('competitivePrice'), src: '/src/assets/main/benefits/competition.svg', alt: this.$t('competition') }
                ]
            };
        }
    };
</script>

<style lang="scss">
    .benefit-text {
        white-space: pre-line;
    }
</style>